"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayButtonContainer = exports.StyledTitleContainer = exports.ModalCarouselContainer = exports.MediaSlideContainer = exports.DESKTOP_MAX_HEIGHT = exports.MOBILE_MAX_HEIGHT = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.MOBILE_MAX_HEIGHT = '407px';
exports.DESKTOP_MAX_HEIGHT = '220px';
const setHeight = (props) => {
    return props.isMobile ? `height: ${exports.MOBILE_MAX_HEIGHT}` : `max-height: ${exports.DESKTOP_MAX_HEIGHT}`;
};
exports.MediaSlideContainer = styled_components_1.default.div `
  width: 100%;
  ${setHeight};
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: 'transparent';
`;
exports.ModalCarouselContainer = styled_components_1.default.div `
  width: 90%;
  height: 90%;
  top: 45%;
  left: 50%;
  display: flex;
  position: absolute;
  justify-content: center;
  transform: translate(-50%, -50%);
  flex-direction: column;
`;
exports.StyledTitleContainer = styled_components_1.default.div `
  margin-bottom: 23px;
  text-align: left;
`;
exports.PlayButtonContainer = styled_components_1.default.div `
  border-left: 50px solid white;
  border-right: 0px solid transparent;
  border-top: 25px solid transparent;
  border-bottom: 30px solid transparent;
  width: 0px;
  height: 0px;
  position: absolute;
  left: 45%;
  top: 40%;
  justify-content: center;
  display: flex;
  border-style: solid;
  background: transparent;
  cursor: pointer;
`;
